import styled from '@emotion/styled';

export const NotificationLink = styled.a`
  cursor: pointer;
  text-decoration: underline;
  color: ${(props) => props.theme.typography.colorPrimary};
`;
